/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetPossibleSecretsGraphQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetPossibleSecretsGraphQuery = {
  readonly __typename: "Query";
  readonly orgSecrets: ReadonlyArray<{
    readonly __typename: "Secret";
    readonly id: c.SecretId;
    readonly name: c.SecretName;
  }>;
};

export const GetPossibleSecretsGraphDocument = /*#__PURE__*/ gql`
  query GetPossibleSecretsGraph($orgId: OrgId!) {
    orgSecrets(orgId: $orgId) {
      id
      name
    }
  }
`;

/**
 * __useGetPossibleSecretsGraphQuery__
 *
 * To run a query within a React component, call `useGetPossibleSecretsGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPossibleSecretsGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPossibleSecretsGraphQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetPossibleSecretsGraphQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPossibleSecretsGraphQuery,
    GetPossibleSecretsGraphQueryVariables
  > &
    (
      | { variables: GetPossibleSecretsGraphQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPossibleSecretsGraphQuery,
    GetPossibleSecretsGraphQueryVariables
  >(GetPossibleSecretsGraphDocument, options);
}
export function useGetPossibleSecretsGraphLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPossibleSecretsGraphQuery,
    GetPossibleSecretsGraphQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPossibleSecretsGraphQuery,
    GetPossibleSecretsGraphQueryVariables
  >(GetPossibleSecretsGraphDocument, options);
}
// @ts-ignore
export function useGetPossibleSecretsGraphSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPossibleSecretsGraphQuery,
    GetPossibleSecretsGraphQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPossibleSecretsGraphQuery,
  GetPossibleSecretsGraphQueryVariables
>;
export function useGetPossibleSecretsGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPossibleSecretsGraphQuery,
        GetPossibleSecretsGraphQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPossibleSecretsGraphQuery | undefined,
  GetPossibleSecretsGraphQueryVariables
>;
export function useGetPossibleSecretsGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPossibleSecretsGraphQuery,
        GetPossibleSecretsGraphQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPossibleSecretsGraphQuery,
    GetPossibleSecretsGraphQueryVariables
  >(GetPossibleSecretsGraphDocument, options);
}
export type GetPossibleSecretsGraphQueryHookResult = ReturnType<
  typeof useGetPossibleSecretsGraphQuery
>;
export type GetPossibleSecretsGraphLazyQueryHookResult = ReturnType<
  typeof useGetPossibleSecretsGraphLazyQuery
>;
export type GetPossibleSecretsGraphSuspenseQueryHookResult = ReturnType<
  typeof useGetPossibleSecretsGraphSuspenseQuery
>;
export type GetPossibleSecretsGraphQueryResult = Apollo.QueryResult<
  GetPossibleSecretsGraphQuery,
  GetPossibleSecretsGraphQueryVariables
>;
